<template>
  <a-row>
    <a-col :span="24">
      <label>当前余额：</label>{{balance}}元
    </a-col>
    <a-col :span="24">
      <a-form-item label="充值" 
        :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
        :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
        style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="充值" v-model="charge"/>
      </a-form-item>
    </a-col>
    <a-col :span="24">
      <a-button type="primary" @click="chargeForAgent">充值</a-button>
    </a-col>
  </a-row>
</template>

<script>

export default {
  name: 'ChargeAgent',
  data() {
    return {
      charge: 0.0,
      refresh: 0,
    }
  },
  props: {
    uid: {
      type: String,
      default: function () {
        return ""
      }
    },
    balance: {
      type: Number,
      default: function () {
        return 0.0
      }
    }
  },
  watch: {
    uid: function(newvalue, oldvalue) {
    },
    balance: function(newvalue, oldvalue) {
    }
  },
  methods: {
    chargeForAgent: function () {
      let postdata = {
        task: "CHARGE_FOR_AGENT",
        charge: this.charge,
        uid: this.uid
      };
      let that = this;
      that.post("manager", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success("充值成功");
            that.$emit("change", postdata["task"]);
          }
        }).catch(function (e) {
      });
    }
  },
  created() {
  }
}
</script>

<style scoped>
</style>
